var _style, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _path2, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLusukuSearchbinoculars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#023A05;}\n\t.st1{fill:#049B0B;}\n\t.st2{fill:#03660C;}\n\t.st3{fill:#F5F5F5;}\n\t.st4{fill:#C9C9C9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "st0",
    d: "M51.9,76.2c0,1.2,0.1,2.4,0.4,3.5c2.8-6.6,9.8-11.3,18.2-11.3c9.3,0,17.2,5.9,19,13.8 c0.8-1.9,1.2-4,1.2-6.1c0-9.6-8.7-17.3-19.4-17.3C60.6,58.9,51.9,66.6,51.9,76.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "st1",
    d: "M87.2,33.5c-4.5,0.6-7.9,4.4-7.9,9l0,0.5h0l0.5,9.4l6.4-1c2.3,0.5,4.8,0.2,6.8-1.1l7.4-1.2L97,40.2 C95.9,35.8,91.7,32.9,87.2,33.5L87.2,33.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.7,42.4c0-5-4-9-9-9c-4.1,0-7.7,2.8-8.7,6.8l-3.4,8.7l7.4,1.2c2,1.3,4.5,1.7,6.8,1.1l6.4,1l0.5-9.4 L61.7,42.4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "st2",
    d: "M90.1,45.8c-8.2,1.3-14.2,8.3-14.2,16.6c0,0.5,0,1,0.1,1.5l-0.1,0l2.1,23.5 c0.2,10.9,9.2,19.6,20.1,19.4c0.4,0,0.8,0,1.2-0.1c10.3-0.9,18.1-9.5,18.1-19.8c0-3-0.7-6-2-8.7l-6.9-20.8 C106.1,49.5,98.3,44.5,90.1,45.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "st2",
    d: "M32.8,57.5l-7.2,20.8c-0.7,1.4-1.2,2.9-1.5,4.4c-1.6,7.1,0.8,14.4,6.1,19.2c5.4,4.8,12.9,6.3,19.7,3.8 c6.8-2.5,11.7-8.4,12.9-15.5v0c0.1-0.8,0.2-1.5,0.2-2.3l2.5-24l-0.1,0C66.2,55,60,47.1,51.2,45.8C43,44.6,35.2,49.5,32.8,57.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "st0",
    d: "M23.6,87.7c0,10.6,8.9,19.2,19.8,19.2s19.8-8.6,19.8-19.2c0-10.6-8.9-19.2-19.8-19.2 C32.4,68.5,23.6,77.1,23.6,87.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "st0",
    d: "M77.8,87.7c0,10.6,8.9,19.2,19.8,19.2s19.8-8.6,19.8-19.2c0-10.6-8.9-19.2-19.8-19.2 S77.8,77.1,77.8,87.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    className: "st3",
    d: "M84.8,87.7c0,6.9,5.8,12.5,12.9,12.5s12.9-5.6,12.9-12.5c0-6.9-5.8-12.5-12.9-12.5S84.8,80.8,84.8,87.7 z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "h",
    className: "st4",
    d: "M97.6,75.2c-7.1,0-12.9,5.6-12.9,12.5c0,3.3,1.3,6.4,3.7,8.7l17.8-18C103.9,76.3,100.8,75.2,97.6,75.2 L97.6,75.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.3,100.1c7.1,0,12.9-5.6,12.9-12.4c0-6.9-5.8-12.5-12.9-12.5s-12.9,5.6-12.9,12.5 C30.5,94.5,36.2,100.1,43.3,100.1"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "st4",
    d: "M43.3,75.2c-7.1,0-12.9,5.6-12.9,12.5c0,3.3,1.3,6.4,3.7,8.7l17.8-18C49.6,76.3,46.6,75.2,43.3,75.2 L43.3,75.2L43.3,75.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLusukuSearchbinoculars);
export default __webpack_public_path__ + "static/media/lusuku_search binoculars.cf0629fdbacc774f17f5d9f46b11362b.svg";
export { ForwardRef as ReactComponent };